class @ContentEditorVisibilityManager

  @setup: ->

    $(".content-editor-section")
      .not(".setup-complete")
      .each ->
        new ContentEditorVisibilityManager(@)

  constructor: (@contentEditorSection) ->

    @$contentEditorSection = $(@contentEditorSection)
    @$contentModeSelect    = $("select.content-mode", @$contentEditorSection)
    @$contentFormatSelect  = $("select.content-format", @$contentEditorSection)

    @$contentModeSelect.on("change", @adjustVisibility)
    @$contentFormatSelect.on("change", @adjustVisibility)

    @adjustVisibility()

    @$contentEditorSection.addClass("setup-complete")

  adjustVisibility: =>

    show = ($elements) =>
      $elements.attr("data-is-editor-section-visible", "1").show()

    hide = ($elements) =>
      $elements.attr("data-is-editor-section-visible", "0").hide()

    format = @$contentFormatSelect.val() || "html"
    mode   = @$contentModeSelect.val()   || ""
    $subs  = $(".editor_subsection", @$contentEditorSection)

    $(".content-format", @$contentEditorSection).toggle(mode != "boilerplate")
    $(".content-subject", @$contentEditorSection).toggle(mode != "boilerplate")
    $(".content-url", @$contentEditorSection).toggle(mode == "redirect")
    $(".generate-from-html-link", @$contentEditorSection).toggle(format == "both")

    if mode != ""
      activeSubsections = ".editor_subsection_#{mode}"
      hide($subs.not(activeSubsections))
      show($subs.filter(activeSubsections))
    else
      show($subs)

    if format == "html"
      hide($subs.filter(".editor_subsection_text"))
    else if format == "text"
      hide($subs.filter(".editor_subsection_html"))
